import {
  IconGauge,
  IconNotes,
  IconCalendar,
  IconMail,
  IconSettings,
  IconUsers,
  IconBook,
} from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { usePatient } from '@/contexts/PatientContext';

export function useNavbarLinks() {
  const { patient, patients } = usePatient();
  const { t } = useTranslation();

  if (!patients.length) return [];

  return [
    {
      label: t('elo_nav_bar.dashboard'),
      icon: IconGauge,
      link: `/patients/${patient ? patient?.id : patients[0]?.id || '0'}/dashboard`,
    },
    {
      label: t('elo_nav_bar.sessions'),
      icon: IconNotes,
      link: `/patients/${patient ? patient?.id : patients[0]?.id || '0'}/sessions`,
    },
    {
      label: t('elo_nav_bar.patients'),
      icon: IconUsers,
      link: '/patients',
    },
    {
      label: t('elo_nav_bar.agenda'),
      icon: IconCalendar,
      links: [
        { label: t('elo_nav_bar.bookings'), link: `/agenda` },
        { label: t('elo_nav_bar.invoices'), link: `/agenda/invoices` },
        { label: t('elo_nav_bar.configuration'), link: `/agenda/configuration` },
      ],
    },
    {
      label: 'Marketing',
      icon: IconMail,
      link: '/marketing',
    },
    {
      label: t('elo_nav_bar.settings.name'),
      icon: IconSettings,
      links: [
        { label: t('elo_nav_bar.settings.profile'), link: `/profile` },
        { label: t('elo_nav_bar.settings.integrations'), link: `/configuration/integrations` },
      ],
    },
    {
      label: t('elo_nav_bar.community'),
      icon: IconBook,
      link: '/community',
    },
  ];
}
